import type { AdminRole } from '@/lib/api-admin/types';

// QA-514(settlement #16) — 운영 관리자도 MD 와 같은 범위(조회·쓰기). 후원자 배송지 원문은 SUPER 전용 그대로(canViewPlainShippingDetail).
export const FUNDING_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'MD_MANAGER',
  'OPS_ADMIN',
  'AUDITOR',
];

export const FUNDING_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'MD_MANAGER',
  'OPS_ADMIN',
];

export const FUNDING_EXPORT_PLAIN_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN'];

export const canPerformFundingWrite = (roles: ReadonlyArray<AdminRole>): boolean =>
  FUNDING_WRITE_ROLES.some((r) => roles.includes(r));

export const canViewPlainShippingDetail = (
  roles: ReadonlyArray<AdminRole>,
): boolean => roles.includes('SUPER_ADMIN');

export const canExportPlainPii = (roles: ReadonlyArray<AdminRole>): boolean =>
  FUNDING_EXPORT_PLAIN_ROLES.some((r) => roles.includes(r));
